/* =============================================================
   MUK Blocks -> Shopify migration : frontend behaviour
   ============================================================= */
(function () {
  'use strict';

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- GSAP + ScrollTrigger loader (parallax + scroll reveals) ---------- */
  var gsapReady = null;
  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = src; s.async = true;
      s.onload = resolve; s.onerror = reject;
      document.head.appendChild(s);
    });
  }
  function loadGsap() {
    if (window.gsap && window.ScrollTrigger) return Promise.resolve(true);
    if (gsapReady) return gsapReady;
    gsapReady = loadScript('https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js')
      .then(function () { return loadScript('https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/ScrollTrigger.min.js'); })
      .then(function () { return true; })
      .catch(function () { return false; });
    return gsapReady;
  }

  /* ---------- Scroll reveals + parallax (matches old WP GSAP classes) ---------- */
  function initAnimations(scope) {
    if (REDUCED) return;
    scope = scope || document;
    var reveal = scope.querySelectorAll('.muk-block .element-to-animate:not([data-anim]), .muk-block .fade-in:not([data-anim])');
    var fromRight = scope.querySelectorAll('.muk-block .slide-from-right:not([data-anim]), .muk-block .slide-from-right1:not([data-anim]), .muk-block .explore-box-right:not([data-anim])');
    var parallax = scope.querySelectorAll('.muk-block .parallax-item:not([data-anim]), .muk-block .parallax-item1:not([data-anim])');
    if (!reveal.length && !fromRight.length && !parallax.length) return;

    loadGsap().then(function (ok) {
      if (!ok || !window.gsap) return;
      var gsap = window.gsap;
      gsap.registerPlugin(window.ScrollTrigger);

      reveal.forEach(function (el) {
        el.setAttribute('data-anim', '1');
        gsap.from(el, {
          opacity: 0, y: 40, duration: 0.9, ease: 'power2.out',
          scrollTrigger: { trigger: el, start: 'top 85%', toggleActions: 'play none none none' }
        });
      });

      fromRight.forEach(function (el) {
        el.setAttribute('data-anim', '1');
        gsap.from(el, {
          opacity: 0, x: 90, duration: 1, ease: 'power3.out',
          scrollTrigger: { trigger: el, start: 'top 88%', toggleActions: 'play none none none' }
        });
      });

      parallax.forEach(function (el) {
        el.setAttribute('data-anim', '1');
        gsap.fromTo(el,
          { yPercent: -8 },
          { yPercent: 8, ease: 'none',
            scrollTrigger: { trigger: el.parentElement || el, start: 'top bottom', end: 'bottom top', scrub: true } }
        );
      });

      window.ScrollTrigger.refresh();
    });
  }

  /* ---------- Splide loader (hero / logo sliders) ---------- */
  var splideReady = null;
  function loadSplide() {
    if (window.Splide) return Promise.resolve(window.Splide);
    if (splideReady) return splideReady;
    var url = document.body.getAttribute('data-splide-src') || (window.__mukSplideSrc || '');
    splideReady = new Promise(function (resolve) {
      if (!url) { resolve(window.Splide); return; }
      var s = document.createElement('script');
      s.src = url;
      s.onload = function () { resolve(window.Splide); };
      document.head.appendChild(s);
    });
    return splideReady;
  }

  function initSplideSliders() {
    var heroes = document.querySelectorAll('[data-muk-hero-slider]:not([data-splide-init])');
    var logos = document.querySelectorAll('[data-muk-logo-slider]:not([data-splide-init])');
    if (!heroes.length && !logos.length) return;
    loadSplide().then(function (Splide) {
      if (!Splide) return;
      heroes.forEach(function (el) {
        el.setAttribute('data-splide-init', '1');
        new Splide(el, {
          type: el.getAttribute('data-loop') === 'true' ? 'loop' : 'slide',
          arrows: el.getAttribute('data-arrows') === 'true',
          pagination: el.getAttribute('data-pagination') !== 'false',
          autoplay: el.getAttribute('data-autoplay') === 'true',
          interval: parseInt(el.getAttribute('data-interval'), 10) || 5000,
          speed: 700
        }).mount();
      });
      logos.forEach(function (el) {
        el.setAttribute('data-splide-init', '1');
        new Splide(el, {
          type: 'loop',
          perPage: 2,
          gap: '1rem',
          arrows: false,
          pagination: false,
          autoScroll: true,
          mediaQuery: 'min',
          breakpoints: { 768: { perPage: parseInt(el.getAttribute('data-per-page'), 10) || 5, gap: '1.5rem' } }
        }).mount();
      });
    });
  }

  /* ---------- Accordion (+/- toggle) ---------- */
  function initAccordions(scope) {
    (scope || document).querySelectorAll('.accordion .accordion-item button').forEach(function (btn) {
      if (btn.__mukBound) return;
      btn.__mukBound = true;
      btn.addEventListener('click', function () {
        var content = btn.nextElementSibling;
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));
        if (content) content.style.maxHeight = open ? null : content.scrollHeight + 'px';
      });
    });
  }

  /* ---------- WooCommerce style tab accordion (faq.php / proproduct) ---------- */
  function initTabAccordions(scope) {
    (scope || document).querySelectorAll('.woocommerce-tabs .description_tab .description-toggle').forEach(function (toggle) {
      if (toggle.__mukBound) return;
      toggle.__mukBound = true;
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        var tab = toggle.closest('.description_tab');
        var content = tab.querySelector('.tab-content');
        var open = tab.classList.toggle('is-open');
        if (content) content.style.display = open ? 'block' : 'none';
      });
    });
  }

  /* ---------- Ingredients read more ---------- */
  function initReadMore(scope) {
    (scope || document).querySelectorAll('.ingredients-accordion').forEach(function (content) {
      var btn = content.parentElement.querySelector('.read-more-btn');
      if (!btn || btn.__mukBound) return;
      btn.__mukBound = true;
      var max = parseInt(window.getComputedStyle(content).getPropertyValue('max-height'), 10);
      if (content.scrollHeight > max) btn.style.display = 'block';
      btn.addEventListener('click', function () {
        var expanded = content.classList.toggle('expanded');
        btn.textContent = expanded ? 'Show less' : 'Read more';
      });
    });
  }

  /* ---------- Routines home carousel ---------- */
  function initRoutinesCarousels(scope) {
    (scope || document).querySelectorAll('.carousel-container').forEach(function (container) {
      if (container.__mukBound) return;
      container.__mukBound = true;
      var wrapper = container.querySelector('.carousel-wrapper');
      var slides = Array.prototype.slice.call(container.querySelectorAll('.carousel-slide'));
      var left = container.querySelector('.carousel-arrow-left');
      var right = container.querySelector('.carousel-arrow-right');
      if (!wrapper || slides.length < 2) return;
      var index = 0;
      function update() {
        var w = slides[0].getBoundingClientRect().width;
        wrapper.style.transform = 'translateX(-' + (index * w) + 'px)';
      }
      if (left) left.addEventListener('click', function () { index = index > 0 ? index - 1 : slides.length - 1; update(); });
      if (right) right.addEventListener('click', function () { index = index < slides.length - 1 ? index + 1 : 0; update(); });
      window.addEventListener('resize', update);
    });
  }

  /* ---------- Grid slider arrows ---------- */
  function initGridSliders(scope) {
    (scope || document).querySelectorAll('.muk-grid-slider').forEach(function (el) {
      if (el.__mukBound) return;
      el.__mukBound = true;
      var track = el.querySelector('.grid-track');
      var prev = el.querySelector('[data-grid-prev]');
      var next = el.querySelector('[data-grid-next]');
      if (prev) prev.addEventListener('click', function () { track.scrollLeft -= 290; });
      if (next) next.addEventListener('click', function () { track.scrollLeft += 290; });
    });
  }

  /* ---------- Routine bundle : add all products to Shopify cart ---------- */
  function initBundleAddToCart() {
    if (document.__mukBundleBound) return;
    document.__mukBundleBound = true;
    document.addEventListener('click', function (e) {
      var button = e.target.closest('.add-bundle-to-cart');
      if (!button) return;
      e.preventDefault();
      var spinner = button.querySelector('.loading-spinner');
      if (spinner) spinner.style.display = 'inline-block';

      var ids = [];
      try { ids = JSON.parse(button.getAttribute('data-variant-ids') || '[]'); } catch (err) { ids = []; }
      if (!ids.length) { if (spinner) spinner.style.display = 'none'; return; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: ids.map(function (id) { return { id: id, quantity: 1 }; }) })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          if (spinner) spinner.style.display = 'none';
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          var code = button.getAttribute('data-discount-code');
          if (code) {
            window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
          } else if (window.location.pathname.indexOf('/cart') === -1) {
            window.location.href = '/cart';
          } else {
            window.location.reload();
          }
        })
        .catch(function () { if (spinner) spinner.style.display = 'none'; });
    });
  }

  /* ---------- Legacy muk PDP gallery + variant state ---------- */
  function initOldProductPage(scope) {
    (scope || document).querySelectorAll('[data-muk-product-gallery]').forEach(function (gallery) {
      if (gallery.__mukGalleryBound) return;
      gallery.__mukGalleryBound = true;
      var main = gallery.querySelector('[data-muk-gallery-main]');
      var zoom = gallery.querySelector('.muk-old-product__zoom');
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-muk-gallery-src]'));
      var modal = gallery.querySelector('[data-muk-gallery-modal]');
      var modalImage = gallery.querySelector('[data-muk-gallery-modal-image]');
      var modalClose = gallery.querySelector('[data-muk-gallery-close]');
      var activeIndex = Math.max(0, thumbs.findIndex(function (item) { return item.classList.contains('is-active'); }));
      var timer = null;
      var previousFocus = null;

      function showThumb(index) {
        if (!main || !thumbs.length) return;
        activeIndex = (index + thumbs.length) % thumbs.length;
        var thumb = thumbs[activeIndex];
        main.src = thumb.getAttribute('data-muk-gallery-src');
        main.removeAttribute('srcset');
        if (zoom) zoom.setAttribute('data-muk-gallery-full', thumb.getAttribute('data-muk-gallery-full') || main.src);
        thumbs.forEach(function (item, itemIndex) {
          var active = itemIndex === activeIndex;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', String(active));
        });
      }

      function stopTimer() {
        if (timer) window.clearInterval(timer);
        timer = null;
      }

      function startTimer() {
        stopTimer();
        if (thumbs.length > 1 && (!modal || modal.hidden)) {
          timer = window.setInterval(function () { showThumb(activeIndex + 1); }, 4000);
        }
      }

      function closeModal() {
        if (!modal || modal.hidden) return;
        modal.hidden = true;
        document.body.classList.remove('muk-gallery-modal-open');
        if (modalImage) modalImage.src = '';
        if (previousFocus) previousFocus.focus();
        startTimer();
      }

      gallery.addEventListener('click', function (event) {
        var thumb = event.target.closest('[data-muk-gallery-src]');
        if (thumb) {
          showThumb(thumbs.indexOf(thumb));
          startTimer();
          return;
        }
        if (event.target.closest('[data-muk-gallery-zoom]') && modal && modalImage && main) {
          previousFocus = event.target.closest('[data-muk-gallery-zoom]');
          modalImage.src = previousFocus.getAttribute('data-muk-gallery-full') || main.src;
          modal.hidden = false;
          document.body.classList.add('muk-gallery-modal-open');
          stopTimer();
          if (modalClose) modalClose.focus();
          return;
        }
        if (event.target === modal || event.target.closest('[data-muk-gallery-close]')) closeModal();
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && modal && !modal.hidden) closeModal();
      });
      startTimer();
    });

    (scope || document).querySelectorAll('.muk-old-product__select').forEach(function (select) {
      if (select.__mukVariantBound) return;
      select.__mukVariantBound = true;
      select.addEventListener('change', function () {
        var root = select.closest('.muk-old-product');
        var option = select.options[select.selectedIndex];
        if (!root || !option) return;
        var available = option.getAttribute('data-available') === 'true';
        var price = root.querySelector('[data-muk-price]');
        var stock = root.querySelector('[data-muk-stock]');
        var add = root.querySelector('.muk-old-product__add');
        var compare = option.getAttribute('data-compare-price');
        if (price) price.innerHTML = '<span>' + (option.getAttribute('data-price') || '') + '</span>' + (compare ? '<s>' + compare + '</s>' : '');
        if (stock) {
          stock.textContent = available ? 'In stock' : 'Out of stock';
          stock.classList.toggle('is-sold-out', !available);
        }
        if (add) {
          add.disabled = !available;
          add.textContent = available ? 'Add to cart' : 'Sold out';
        }
        var mediaSrc = option.getAttribute('data-media-src');
        var main = root.querySelector('[data-muk-gallery-main]');
        if (mediaSrc && main) { main.src = mediaSrc; main.removeAttribute('srcset'); }
      });
    });
  }

  /* ---------- Legacy PDP before/after image parallax ---------- */
  function initOldPdpParallax(scope) {
    if (REDUCED) return;
    var items = (scope || document).querySelectorAll('[data-muk-parallax]:not([data-muk-parallax-ready])');
    if (!items.length) return;
    items.forEach(function (item) { item.setAttribute('data-muk-parallax-ready', 'true'); });
    var ticking = false;
    function update() {
      ticking = false;
      items.forEach(function (item) {
        if (!item.isConnected) return;
        var section = item.closest('[data-muk-parallax-section], .muk-old-benefits') || item.parentElement;
        var rect = section.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > window.innerHeight) return;
        var progress = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
        progress = Math.max(0, Math.min(1, progress)) - 0.5;
        var speed = parseFloat(item.getAttribute('data-muk-parallax-speed') || '0.1');
        item.style.setProperty('--muk-parallax-y', Math.round(progress * speed * 900) + 'px');
      });
    }
    function requestUpdate() {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    requestUpdate();
  }

  /* ---------- Init ---------- */
  function initAll(scope) {
    initSplideSliders();
    initAccordions(scope);
    initTabAccordions(scope);
    initReadMore(scope);
    initRoutinesCarousels(scope);
    initGridSliders(scope);
    initBundleAddToCart();
    initOldProductPage(scope);
    initOldPdpParallax(scope);
    initAnimations(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  // Re-init inside Shopify theme editor when a section is (re)loaded
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

/* MUK PDP V3b controls + mobile sticky add-to-cart */
(function () {
  function moneyFromCents(cents, fallback) {
    if (typeof cents !== 'number' || isNaN(cents)) return fallback || '';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AUD'
      }).format(cents / 100);
    } catch (e) {
      return fallback || '';
    }
  }

  function initMukPdpV3(scope) {
    (scope || document).querySelectorAll('[data-muk-pdp-v3]').forEach(function (root) {
      if (root.__mukPdpV3Bound) return;
      root.__mukPdpV3Bound = true;

      var mainForm = root.querySelector('.muk-pdp-v3__form');
      var variantInput = root.querySelector('[data-muk-variant-input]');
      var select = root.querySelector('[data-muk-variant-select]');
      var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-muk-variant-button]'));
      var price = root.querySelector('[data-muk-price]');
      var afterpay = root.querySelector('[data-muk-afterpay-amount]');
      var add = root.querySelector('[data-muk-add-button]');
      var mainImage = root.querySelector('[data-muk-gallery-main]');
      var gallery = root.querySelector('[data-muk-pdp-gallery]');
      var galleryMain = root.querySelector('.muk-pdp-v3__main-media');
      var galleryThumbs = [];
      var galleryThumbsContainer = root.querySelector('[data-muk-gallery-thumbs]');
      var galleryDataNode = root.querySelector('[data-muk-gallery-data]');
      var galleryData = { media: [], variants: [] };
      try {
        if (galleryDataNode) galleryData = JSON.parse(galleryDataNode.textContent || '{}');
      } catch (e) {
        galleryData = { media: [], variants: [] };
      }
      var galleryThumbNav = root.querySelector('[data-muk-gallery-thumb-nav]');
      var galleryPrev = root.querySelector('[data-muk-gallery-prev]');
      var galleryNext = root.querySelector('[data-muk-gallery-next]');
      var qty = root.querySelector('[data-muk-qty-input]');
      var sticky = root.querySelector('[data-muk-sticky-cart]');
      var stickyVariantInput = root.querySelector('[data-muk-sticky-variant-input]');
      var stickySelect = root.querySelector('[data-muk-sticky-variant-select]');
      var stickyQty = root.querySelector('[data-muk-sticky-qty-input]');
      var stickyAdd = root.querySelector('[data-muk-sticky-add]');
      var primaryBuy = root.querySelector('[data-muk-primary-buy]');
      var headerShell = document.querySelector('[data-muk-sticky-header]') || document.querySelector('.muk-header-shell');
      var footer = document.querySelector('.muk-site-footer, footer.shopify-section, #shopify-section-footer-group');
      var actionVideo = root.querySelector('[data-muk-action-video]');
      var actionIframe = root.querySelector('[data-muk-action-iframe]');
      var soundToggle = root.querySelector('[data-muk-video-sound]');
      var soundLabel = root.querySelector('[data-muk-video-sound-label]');

      var galleryMedia = Array.isArray(galleryData.media) ? galleryData.media : [];
      var galleryVariants = Array.isArray(galleryData.variants) ? galleryData.variants : [];
      var useVariantGallery = galleryData.useVariantGallery === true;
      var variantMediaById = {};
      var variantTitleById = {};

      galleryVariants.forEach(function (variant) {
        if (!variant || variant.id === undefined || variant.id === null) return;
        variantMediaById[String(variant.id)] = variant.mediaId === null || variant.mediaId === undefined ? '' : String(variant.mediaId);
        variantTitleById[String(variant.id)] = String(variant.title || '');
      });

      /* Use variant-specific galleries only when Shopify provides a complete,
         unambiguous set of unique variant image anchors. Single-variant products
         and incomplete mappings always retain the complete product gallery. */
      var reliableVariantGallery = (function () {
        if (!useVariantGallery || galleryVariants.length <= 1 || !galleryMedia.length) return false;
        var mediaIds = galleryMedia.map(function (media) { return String(media.id || ''); });
        var anchors = galleryVariants.map(function (variant) {
          return variant && variant.mediaId !== null && variant.mediaId !== undefined ? String(variant.mediaId) : '';
        });
        if (anchors.some(function (id) { return !id || mediaIds.indexOf(id) === -1; })) return false;
        return new Set(anchors).size === galleryVariants.length;
      })();

      function mediaForVariant(variantId) {
        if (!reliableVariantGallery) return galleryMedia.slice();

        var selectedAnchor = variantMediaById[String(variantId)] || '';
        if (!selectedAnchor) return galleryMedia.slice();

        var anchorIds = new Set(galleryVariants.map(function (variant) {
          return variantMediaById[String(variant.id)] || '';
        }).filter(Boolean));
        var startIndex = galleryMedia.findIndex(function (media) {
          return String(media.id || '') === selectedAnchor;
        });
        if (startIndex < 0) return galleryMedia.slice();

        var endIndex = galleryMedia.length;
        for (var i = startIndex + 1; i < galleryMedia.length; i += 1) {
          if (anchorIds.has(String(galleryMedia[i].id || ''))) {
            endIndex = i;
            break;
          }
        }
        var group = galleryMedia.slice(startIndex, endIndex);
        return group.length ? group : galleryMedia.slice();
      }

      function normalizedVariantTokens(title) {
        var value = String(title || '').toLowerCase().replace(/\s+/g, ' ').trim();
        if (!value || value === 'default title') return [];
        var compact = value.replace(/\s+/g, '');
        var tokens = [compact];
        var ml = value.match(/(\d+(?:\.\d+)?)\s*ml/i);
        if (ml) tokens.push(String(ml[1]).replace(/\.0$/, '') + 'ml');
        var litre = value.match(/(\d+(?:\.\d+)?)\s*(?:litre|liter|l)/i);
        if (litre) {
          var litres = parseFloat(litre[1]);
          if (litres > 0) {
            tokens.push(String(Math.round(litres * 1000)) + 'ml');
            tokens.push(String(litre[1]).replace(/\.0$/, '') + 'litre');
          }
        }
        return tokens.filter(function (token, index, list) { return token && list.indexOf(token) === index; });
      }

      function inferredVariantMediaId(variantId, preferredMediaId) {
        var explicitId = preferredMediaId ? String(preferredMediaId) : (variantMediaById[String(variantId)] || '');
        if (explicitId && galleryMedia.some(function (media) { return String(media.id || '') === explicitId; })) return explicitId;

        /* Some migrated merged products lost Shopify's variant-image association even though the
           size-specific gallery images are present. Infer only the active image from a clear size token;
           never hide the rest of the gallery. */
        var tokens = normalizedVariantTokens(variantTitleById[String(variantId)] || '');
        if (!tokens.length) return '';
        var match = galleryMedia.find(function (media) {
          var haystack = (String(media.src || '') + ' ' + String(media.alt || '')).toLowerCase().replace(/[^a-z0-9]+/g, '');
          return tokens.some(function (token) { return haystack.indexOf(String(token).replace(/[^a-z0-9]+/g, '')) !== -1; });
        });
        return match ? String(match.id || '') : '';
      }

      function preloadGalleryThumb(thumb) {
        var fullSrc = thumb && thumb.getAttribute('data-muk-gallery-src');
        if (!fullSrc) return;
        var preload = new Image();
        preload.decoding = 'async';
        preload.src = fullSrc;
        thumb.__mukGalleryPreload = preload;
        if (preload.decode) preload.decode().catch(function () {});
      }

      function visibleGalleryThumbs() {
        return galleryThumbs.slice();
      }

      function galleryIndex() {
        var activeIndex = galleryThumbs.findIndex(function (thumb) { return thumb.classList.contains('is-active'); });
        return activeIndex > -1 ? activeIndex : 0;
      }

      function setGalleryImage(thumb, shouldFocus) {
        if (!thumb || !mainImage) return;
        var src = thumb.getAttribute('data-muk-gallery-src');
        if (!src) return;

        galleryThumbs.forEach(function (item) {
          var active = item === thumb;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', String(active));
        });

        var thumbImage = thumb.querySelector('img');
        var quickSrc = thumbImage && (thumbImage.currentSrc || thumbImage.src);
        var preload = thumb.__mukGalleryPreload;
        mainImage.removeAttribute('srcset');
        mainImage.removeAttribute('sizes');
        if (preload && preload.complete && preload.naturalWidth) {
          mainImage.src = src;
        } else {
          if (quickSrc) mainImage.src = quickSrc;
          if (!preload) {
            preload = new Image();
            preload.decoding = 'async';
            preload.src = src;
            thumb.__mukGalleryPreload = preload;
          }
          var promoteFullImage = function () {
            if (thumb.classList.contains('is-active')) mainImage.src = src;
          };
          if (preload.complete && preload.naturalWidth) promoteFullImage();
          else preload.addEventListener('load', promoteFullImage, { once: true });
        }

        var alt = thumb.getAttribute('data-muk-gallery-alt');
        if (alt) mainImage.alt = alt;
        var activeGalleryMediaId = thumb.getAttribute('data-muk-gallery-media-id') || '';
        mainImage.setAttribute('data-muk-gallery-media-id', activeGalleryMediaId);
        if (galleryMain) {
          var selectedVariantId = variantInput ? String(variantInput.value || '') : '';
          var firstGalleryMediaId = String((galleryMedia[0] && galleryMedia[0].id) || '');
          var selectedPrimaryMediaId = useVariantGallery
            ? (variantMediaById[selectedVariantId] || firstGalleryMediaId)
            : firstGalleryMediaId;
          galleryMain.classList.toggle('is-variant-primary', !!selectedPrimaryMediaId && String(activeGalleryMediaId) === String(selectedPrimaryMediaId));
        }
        if (mainImage.animate) {
          try {
            mainImage.getAnimations().forEach(function (animation) { animation.cancel(); });
            mainImage.animate(
              [{ transform: 'translateX(28px)' }, { transform: 'translateX(0)' }],
              { duration: 240, easing: 'cubic-bezier(.2,.7,.3,1)' }
            );
          } catch (e) {}
        }
        try { thumb.scrollIntoView({ behavior: 'auto', inline: 'nearest', block: 'nearest' }); } catch (e) {}
        if (shouldFocus) {
          try { thumb.focus({ preventScroll: true }); } catch (e) { thumb.focus(); }
        }
      }

      function moveGallery(step) {
        if (!galleryThumbs.length) return;
        var nextIndex = (galleryIndex() + step + galleryThumbs.length) % galleryThumbs.length;
        setGalleryImage(galleryThumbs[nextIndex], false);
      }

      function makeGalleryThumb(media, index, total, activeMediaId) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'muk-pdp-v3__thumb';
        button.setAttribute('data-muk-gallery-src', media.src || '');
        button.setAttribute('data-muk-gallery-alt', media.alt || '');
        button.setAttribute('data-muk-gallery-media-id', String(media.id || ''));
        button.setAttribute('data-muk-gallery-index', String(index));
        button.setAttribute('aria-label', 'View product image ' + (index + 1) + ' of ' + total);
        var active = String(media.id || '') === String(activeMediaId || '');
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));

        var image = document.createElement('img');
        image.src = media.thumb || media.src || '';
        image.alt = media.alt || '';
        image.loading = 'lazy';
        image.decoding = 'async';
        button.appendChild(image);
        preloadGalleryThumb(button);
        return button;
      }

      function renderGalleryForVariant(variantId, preferredMediaId) {
        var mediaItems = mediaForVariant(variantId, preferredMediaId);
        if (!mediaItems.length) return false;

        var resolvedVariantMediaId = reliableVariantGallery
          ? (variantMediaById[String(variantId)] || '')
          : inferredVariantMediaId(variantId, preferredMediaId);
        var activeMediaId = resolvedVariantMediaId || String(mediaItems[0].id || '');
        if (!mediaItems.some(function (media) { return String(media.id || '') === activeMediaId; })) {
          activeMediaId = String(mediaItems[0].id || '');
        }
        variantMediaById[String(variantId)] = resolvedVariantMediaId;

        galleryThumbs = [];
        if (galleryThumbsContainer) {
          galleryThumbsContainer.replaceChildren();
          mediaItems.forEach(function (media, index) {
            var thumb = makeGalleryThumb(media, index, mediaItems.length, activeMediaId);
            galleryThumbs.push(thumb);
            galleryThumbsContainer.appendChild(thumb);
          });
        }

        if (galleryThumbNav) galleryThumbNav.hidden = mediaItems.length <= 1;
        if (galleryPrev) galleryPrev.disabled = mediaItems.length <= 1;
        if (galleryNext) galleryNext.disabled = mediaItems.length <= 1;

        var activeThumb = galleryThumbs.find(function (thumb) {
          return String(thumb.getAttribute('data-muk-gallery-media-id') || '') === activeMediaId;
        });
        if (activeThumb) {
          setGalleryImage(activeThumb, false);
        } else if (mainImage) {
          var activeMedia = mediaItems.find(function (media) { return String(media.id || '') === activeMediaId; }) || mediaItems[0];
          mainImage.removeAttribute('srcset');
          mainImage.removeAttribute('sizes');
          mainImage.src = activeMedia.src || '';
          mainImage.alt = activeMedia.alt || mainImage.alt || '';
          var activeGalleryMediaId = String(activeMedia.id || '');
          mainImage.setAttribute('data-muk-gallery-media-id', activeGalleryMediaId);
          if (galleryMain) {
            var selectedVariantId = variantInput ? String(variantInput.value || '') : '';
            var firstGalleryMediaId = String((galleryMedia[0] && galleryMedia[0].id) || '');
            var selectedPrimaryMediaId = useVariantGallery
              ? (variantMediaById[selectedVariantId] || firstGalleryMediaId)
              : firstGalleryMediaId;
            galleryMain.classList.toggle('is-variant-primary', !!selectedPrimaryMediaId && activeGalleryMediaId === String(selectedPrimaryMediaId));
          }
          if (mainImage.animate) {
            try {
              mainImage.getAnimations().forEach(function (animation) { animation.cancel(); });
              mainImage.animate(
                [{ transform: 'translateX(28px)' }, { transform: 'translateX(0)' }],
                { duration: 240, easing: 'cubic-bezier(.2,.7,.3,1)' }
              );
            } catch (e) {}
          }
        }
        return true;
      }


      /* Some migrated rich-text metafields can arrive as serialized Shopify JSON.
         Render that structure instead of exposing the JSON string to customers. */
      root.querySelectorAll('[data-muk-richtext-json]').forEach(function (node) {
        var raw = (node.textContent || '').trim();
        if (!raw || raw.charAt(0) !== '{' || raw.indexOf('\"type\"') === -1) return;
        var parsed;
        try { parsed = JSON.parse(raw); } catch (e) { return; }
        if (!parsed || parsed.type !== 'root' || !Array.isArray(parsed.children)) return;

        function appendInline(parent, children) {
          (children || []).forEach(function (child) {
            if (!child) return;
            if (child.type === 'text') {
              var textNode = document.createTextNode(child.value || '');
              if (child.bold) {
                var strong = document.createElement('strong');
                strong.appendChild(textNode); parent.appendChild(strong);
              } else if (child.italic) {
                var em = document.createElement('em');
                em.appendChild(textNode); parent.appendChild(em);
              } else parent.appendChild(textNode);
            } else if (child.type === 'link') {
              var a = document.createElement('a');
              a.href = child.url || '#';
              appendInline(a, child.children); parent.appendChild(a);
            } else if (Array.isArray(child.children)) appendInline(parent, child.children);
          });
        }

        function renderBlock(block) {
          if (!block) return null;
          if (block.type === 'paragraph') {
            var p = document.createElement('p'); appendInline(p, block.children); return p;
          }
          if (block.type === 'list') {
            var list = document.createElement(block.listType === 'ordered' ? 'ol' : 'ul');
            (block.children || []).forEach(function (item) {
              var li = document.createElement('li'); appendInline(li, item.children); list.appendChild(li);
            });
            return list;
          }
          return null;
        }

        var fragment = document.createDocumentFragment();
        parsed.children.forEach(function (block) { var el = renderBlock(block); if (el) fragment.appendChild(el); });
        if (fragment.childNodes.length) node.replaceChildren(fragment);
      });

      function optionDataById(id) {
        var option = select ? Array.prototype.slice.call(select.options).find(function (o) { return String(o.value) === String(id); }) : null;
        var button = buttons.find(function (b) { return String(b.getAttribute('data-variant-id')) === String(id); });
        var source = option || button;
        if (!source) return null;
        return {
          id: String(id),
          price: source.getAttribute('data-price') || (button && button.getAttribute('data-price')) || '',
          priceCents: parseInt(source.getAttribute('data-price-cents') || (button && button.getAttribute('data-price-cents')) || '', 10),
          compare: source.getAttribute('data-compare-price') || (button && button.getAttribute('data-compare-price')) || '',
          available: source.getAttribute('data-available') === 'true' || (button && button.getAttribute('data-available') === 'true'),
          mediaSrc: source.getAttribute('data-media-src') || (button && button.getAttribute('data-media-src')) || '',
          mediaId: source.getAttribute('data-media-id') || (button && button.getAttribute('data-media-id')) || ''
        };
      }

      function setAvailability(button, available) {
        if (!button) return;
        button.disabled = !available;
        button.classList.toggle('is-unavailable', !available);
        button.textContent = available ? 'Add to cart' : 'Out of stock';
      }

      function variantUrl(id) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', String(id));
          return url.toString();
        } catch (e) {
          var separator = window.location.href.indexOf('?') === -1 ? '?' : '&';
          return window.location.href.replace(/([?&])variant=[^&#]*/g, '$1').replace(/[?&]$/, '') + separator + 'variant=' + encodeURIComponent(id);
        }
      }

      function setVariant(id) {
        var data = optionDataById(id);
        if (!data) return;
        var previousId = variantInput ? String(variantInput.value || '') : '';
        if (variantInput) variantInput.value = data.id;
        if (stickyVariantInput) stickyVariantInput.value = data.id;
        if (select && String(select.value) !== data.id) select.value = data.id;
        if (stickySelect && String(stickySelect.value) !== data.id) stickySelect.value = data.id;
        buttons.forEach(function (button) {
          var selected = String(button.getAttribute('data-variant-id')) === data.id;
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-pressed', String(selected));
        });
        if (price && data.price) price.innerHTML = '<span>' + data.price + '</span>' + (data.compare ? '<s>' + data.compare + '</s>' : '');
        if (afterpay && !isNaN(data.priceCents)) afterpay.textContent = moneyFromCents(data.priceCents / 4, '');
        setAvailability(add, data.available);
        setAvailability(stickyAdd, data.available);
        var galleryRendered = renderGalleryForVariant(data.id, data.mediaId);
        if (!galleryRendered && data.mediaSrc && mainImage) {
          mainImage.removeAttribute('srcset');
          mainImage.removeAttribute('sizes');
          mainImage.src = data.mediaSrc;
        }

        /* Keep the selected variant in the URL without reloading the product page. */
        if (previousId !== data.id) {
          try {
            window.history.replaceState({ variant: data.id }, '', variantUrl(data.id));
          } catch (e) {}
          root.classList.remove('is-variant-changing');
          root.removeAttribute('aria-busy');
          root.dispatchEvent(new CustomEvent('muk:variant:change', {
            bubbles: true,
            detail: { variantId: data.id }
          }));
        }
      }

      buttons.forEach(function (button) {
        button.addEventListener('click', function () { setVariant(button.getAttribute('data-variant-id')); });
      });
      if (select) select.addEventListener('change', function () { setVariant(select.value); });
      if (stickySelect) stickySelect.addEventListener('change', function () { setVariant(stickySelect.value); });

      function clampQty(value) { return Math.max(1, parseInt(value, 10) || 1); }
      function setQty(value) {
        value = clampQty(value);
        if (qty) qty.value = value;
        if (stickyQty) stickyQty.value = value;
      }
      var minus = root.querySelector('[data-muk-qty-minus]');
      var plus = root.querySelector('[data-muk-qty-plus]');
      var stickyMinus = root.querySelector('[data-muk-sticky-minus]');
      var stickyPlus = root.querySelector('[data-muk-sticky-plus]');
      if (minus) minus.addEventListener('click', function () { setQty((qty && qty.value) - 1); });
      if (plus) plus.addEventListener('click', function () { setQty(clampQty(qty && qty.value) + 1); });
      if (stickyMinus) stickyMinus.addEventListener('click', function () { setQty((stickyQty && stickyQty.value) - 1); });
      if (stickyPlus) stickyPlus.addEventListener('click', function () { setQty(clampQty(stickyQty && stickyQty.value) + 1); });
      if (qty) qty.addEventListener('change', function () { setQty(qty.value); });
      if (stickyQty) stickyQty.addEventListener('change', function () { setQty(stickyQty.value); });


      function ajaxAddToCart(form) {
        if (!form) return;
        var submitButton = form.querySelector('[type="submit"]');
        if (submitButton && submitButton.disabled) return;
        if (submitButton) {
          submitButton.disabled = true;
          submitButton.setAttribute('aria-busy', 'true');
        }
        var formData = new FormData(form);
        try {
          if (window.Alpine && Alpine.store('xCartHelper')) {
            formData.append('sections', Alpine.store('xCartHelper').getSectionsToRender().map(function (section) { return section.id; }));
            formData.append('sections_url', window.location.pathname);
          }
        } catch (e) {}

        fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        })
        .then(function (response) { return response.json(); })
        .then(function (response) {
          if (response.status === 422) throw new Error(response.description || 'Unable to add item to cart');
          try {
            if (response.sections && window.Alpine && Alpine.store('xCartHelper')) {
              Alpine.store('xCartHelper').getSectionsToRender().forEach(function (section) {
                var element = document.querySelector(section.selector);
                if (element && response.sections[section.id]) {
                  if (typeof window.getSectionInnerHTML === 'function') {
                    element.innerHTML = window.getSectionInnerHTML(response.sections[section.id], section.selector);
                  } else {
                    var parsed = new DOMParser().parseFromString(response.sections[section.id], 'text/html');
                    var replacement = parsed.querySelector(section.selector);
                    element.innerHTML = replacement ? replacement.innerHTML : response.sections[section.id];
                  }
                }
              });
            }
            if (window.Alpine && Alpine.store('xMiniCart')) {
              if (!response.sections && Alpine.store('xMiniCart').reLoad) Alpine.store('xMiniCart').reLoad();
              Alpine.store('xMiniCart').openCart();
            } else {
              window.location.href = '/cart';
            }
            document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
          } catch (e) {
            window.location.href = '/cart';
          }
        })
        .catch(function (error) {
          console.error(error);
          window.location.href = '/cart';
        })
        .finally(function () {
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.removeAttribute('aria-busy');
          }
        });
      }

      var stickyForm = root.querySelector('.muk-pdp-v3__sticky-form');
      if (mainForm) mainForm.addEventListener('submit', function (event) { event.preventDefault(); ajaxAddToCart(mainForm); });
      if (stickyForm) stickyForm.addEventListener('submit', function (event) { event.preventDefault(); ajaxAddToCart(stickyForm); });

      /* Re-use the collection-card cart behaviour for PDP recommendations and pairs. */
      root.querySelectorAll('[data-muk-plp-cart-form]').forEach(function (cardForm) {
        if (cardForm.__mukPdpCardBound) return;
        cardForm.__mukPdpCardBound = true;
        var cardSelect = cardForm.querySelector('[data-muk-card-variant]');
        var cardButton = cardForm.querySelector('[data-muk-card-add]') || cardForm.querySelector('[type="submit"]');
        if (cardSelect && cardButton) {
          cardSelect.addEventListener('change', function () {
            var option = cardSelect.options[cardSelect.selectedIndex];
            cardButton.disabled = !cardSelect.value || (option && option.disabled);
            var imageSrc = option && option.getAttribute('data-variant-image');
            var card = cardForm.closest('[data-muk-plp-card]');
            var image = card && card.querySelector('.muk-plp-card__image--primary');
            if (imageSrc && image) {
              image.src = imageSrc;
              image.removeAttribute('srcset');
            }
          });
        }
        cardForm.addEventListener('submit', function (event) {
          event.preventDefault();
          if (cardSelect && !cardSelect.value) return;
          ajaxAddToCart(cardForm);
        });
      });

      /* Product image carousel: delegated clicks make thumbnails/arrows reliable even after theme DOM updates. */
      if (gallery) {
        gallery.addEventListener('click', function (event) {
          var thumb = event.target.closest('[data-muk-gallery-src]');
          if (thumb && gallery.contains(thumb)) {
            event.preventDefault();
            event.stopPropagation();
            setGalleryImage(thumb, false);
            return;
          }
          if (event.target.closest('[data-muk-gallery-prev]')) {
            event.preventDefault();
            event.stopPropagation();
            moveGallery(-1);
            return;
          }
          if (event.target.closest('[data-muk-gallery-next]')) {
            event.preventDefault();
            event.stopPropagation();
            moveGallery(1);
          }
        });
      }
      if (galleryMain) {
        galleryMain.addEventListener('keydown', function (event) {
          if (event.key === 'ArrowLeft') { event.preventDefault(); moveGallery(-1); }
          if (event.key === 'ArrowRight') { event.preventDefault(); moveGallery(1); }
        });
        var swipeStartX = null;
        galleryMain.addEventListener('touchstart', function (event) {
          if (event.touches && event.touches.length === 1) swipeStartX = event.touches[0].clientX;
        }, { passive: true });
        galleryMain.addEventListener('touchend', function (event) {
          if (swipeStartX === null || !event.changedTouches || !event.changedTouches.length) return;
          var deltaX = event.changedTouches[0].clientX - swipeStartX;
          swipeStartX = null;
          if (Math.abs(deltaX) < 45) return;
          moveGallery(deltaX > 0 ? -1 : 1);
        }, { passive: true });
      }

      /* Autoplay remains muted until a deliberate user click, then toggle sound for native, YouTube or Vimeo video. */
      if (soundToggle) {
        var isMuted = true;
        var iframeSrc = actionIframe ? (actionIframe.getAttribute('src') || '') : '';
        var iframeIsYoutube = /youtube\.com\/embed\//i.test(iframeSrc);
        var iframeIsVimeo = /player\.vimeo\.com\/video\//i.test(iframeSrc);

        if (!actionVideo && !iframeIsYoutube && !iframeIsVimeo) {
          soundToggle.hidden = true;
        } else {
          soundToggle.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopPropagation();
            isMuted = !isMuted;
            if (actionVideo) {
              actionVideo.muted = isMuted;
              if (!isMuted) {
                actionVideo.volume = 1;
                var playPromise = actionVideo.play();
                if (playPromise && playPromise.catch) playPromise.catch(function () {});
              }
            } else if (actionIframe && actionIframe.contentWindow) {
              if (iframeIsYoutube) {
                actionIframe.contentWindow.postMessage(JSON.stringify({
                  event: 'command',
                  func: isMuted ? 'mute' : 'unMute',
                  args: []
                }), '*');
                if (!isMuted) {
                  actionIframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'setVolume', args: [100] }), '*');
                }
              } else if (iframeIsVimeo) {
                actionIframe.contentWindow.postMessage({ method: 'setVolume', value: isMuted ? 0 : 1 }, '*');
              }
            }
            soundToggle.setAttribute('aria-pressed', String(!isMuted));
            soundToggle.classList.toggle('is-unmuted', !isMuted);
            if (soundLabel) soundLabel.textContent = isMuted ? 'Unmute' : 'Mute';
          });
        }
      }

      /* Smooth product detail accordions. */
      var accordionDetails = Array.prototype.slice.call(root.querySelectorAll('.muk-pdp-v3__accordion'));
      accordionDetails.forEach(function (details) {
        var summary = details.querySelector('summary');
        var content = details.querySelector('.muk-pdp-v3__accordion-content');
        if (!summary || !content) return;
        content.style.maxHeight = details.open ? content.scrollHeight + 'px' : '0px';

        summary.addEventListener('click', function (event) {
          event.preventDefault();
          if (details.open) {
            content.style.maxHeight = content.scrollHeight + 'px';
            window.requestAnimationFrame(function () {
              content.style.maxHeight = '0px';
              content.style.opacity = '0';
            });
            window.setTimeout(function () {
              details.open = false;
              updateColumnSticky();
            }, 340);
          } else {
            accordionDetails.forEach(function (otherDetails) {
              if (otherDetails === details || !otherDetails.open) return;
              var otherContent = otherDetails.querySelector('.muk-pdp-v3__accordion-content');
              if (otherContent) {
                otherContent.style.maxHeight = otherContent.scrollHeight + 'px';
                window.requestAnimationFrame(function () {
                  otherContent.style.maxHeight = '0px';
                  otherContent.style.opacity = '0';
                });
              }
              window.setTimeout(function () { otherDetails.open = false; }, 300);
            });
            details.open = true;
            content.style.opacity = '1';
            content.style.maxHeight = '0px';
            window.requestAnimationFrame(function () {
              content.style.maxHeight = content.scrollHeight + 'px';
            });
            window.setTimeout(function () {
              if (details.open) content.style.maxHeight = 'none';
              if (details.open && window.matchMedia('(max-width: 767px)').matches) {
                window.setTimeout(function () { details.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 40);
              }
              updateColumnSticky();
            }, 350);
          }
        });
      });

      /* Stick only the shorter primary PDP column to the viewport. */
      var leftColumn = root.querySelector('[data-muk-pdp-column="left"]');
      var rightColumn = root.querySelector('[data-muk-pdp-column="right"]');
      function updateColumnSticky() {
        if (!leftColumn || !rightColumn) return;
        leftColumn.classList.remove('is-sticky-short');
        rightColumn.classList.remove('is-sticky-short');
        if (!window.matchMedia('(min-width: 991px)').matches) return;
        var leftHeight = leftColumn.scrollHeight;
        var rightHeight = rightColumn.scrollHeight;
        if (Math.abs(leftHeight - rightHeight) < 50) return;
        (leftHeight < rightHeight ? leftColumn : rightColumn).classList.add('is-sticky-short');
      }
      window.addEventListener('resize', updateColumnSticky);
      window.addEventListener('load', updateColumnSticky);
      window.setTimeout(updateColumnSticky, 120);
      window.setTimeout(updateColumnSticky, 700);
      window.setTimeout(updateColumnSticky, 1800);

      /* App blocks (for example Magic Wishlist) and product media can change
         a column's height after the initial render. Re-evaluate which side is
         shorter whenever either primary column changes size so sticky never
         silently drops out after an async app render. */
      if (typeof ResizeObserver !== 'undefined' && leftColumn && rightColumn) {
        var mukColumnResizeFrame = null;
        var mukColumnResizeObserver = new ResizeObserver(function () {
          if (mukColumnResizeFrame) window.cancelAnimationFrame(mukColumnResizeFrame);
          mukColumnResizeFrame = window.requestAnimationFrame(function () {
            mukColumnResizeFrame = null;
            updateColumnSticky();
          });
        });
        mukColumnResizeObserver.observe(leftColumn);
        mukColumnResizeObserver.observe(rightColumn);
      }

      /* R44: Klaviyo reviews remain scrollable when they overflow, but the
         nested review panel must never trap normal page scrolling. At its top/bottom
         boundary (or when it has nothing to scroll), hand the wheel delta back to the page. */
      var reviewsApps = root.querySelector('.muk-pdp-v3__reviews-apps');
      if (reviewsApps && !reviewsApps.dataset.mukWheelHandoff) {
        reviewsApps.dataset.mukWheelHandoff = 'true';
        reviewsApps.addEventListener('wheel', function (event) {
          if (!window.matchMedia('(min-width: 991px)').matches) return;
          var delta = event.deltaY || 0;
          if (!delta) return;
          var maxScroll = Math.max(0, reviewsApps.scrollHeight - reviewsApps.clientHeight);
          var atTop = reviewsApps.scrollTop <= 1;
          var atBottom = reviewsApps.scrollTop >= maxScroll - 1;
          var cannotScroll = maxScroll <= 1;
          if (cannotScroll || (delta < 0 && atTop) || (delta > 0 && atBottom)) {
            event.preventDefault();
            window.scrollBy(0, delta);
          }
        }, { passive: false, capture: true });
      }

      function updateSticky() {
        if (!sticky || !primaryBuy) {
          if (sticky) sticky.classList.remove('is-visible');
          return;
        }
        var buyTrigger = mainForm || primaryBuy;
        var buyRect = buyTrigger.getBoundingClientRect();
        var headerThreshold = 0;
        if (headerShell) {
          var headerRect = headerShell.getBoundingClientRect();
          headerThreshold = Math.max(0, headerRect.bottom);
        }
        /* Show only once the ENTIRE original purchase form (variant + quantity + button)
           has passed above the visible header. This prevents the sticky bar appearing
           while any of the body purchase controls are still visible. */
        var passed = buyRect.bottom <= headerThreshold;
        var footerVisible = false;
        if (footer) {
          var footerRect = footer.getBoundingClientRect();
          footerVisible = footerRect.top < window.innerHeight && footerRect.bottom > 0;
        }
        var show = passed && !footerVisible;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      }

      window.addEventListener('scroll', updateSticky, { passive: true });
      window.addEventListener('resize', updateSticky);
      updateSticky();

      /* Initial gallery render is independent of variant controls.
         Single/default-variant products often have no visible selector, but still need
         every Shopify gallery image rendered. Multi-variant products use the current
         variant when available and safely fall back to the complete gallery otherwise. */
      var initialVariantId = variantInput && variantInput.value
        ? String(variantInput.value)
        : (select && select.value ? String(select.value) : (galleryVariants[0] ? String(galleryVariants[0].id) : ''));
      var initialVariantMediaId = initialVariantId ? (variantMediaById[initialVariantId] || '') : '';
      if (galleryMedia.length) renderGalleryForVariant(initialVariantId, initialVariantMediaId);

      /* Initial variant sync for products that expose variant controls. */
      if (variantInput && variantInput.value) setVariant(variantInput.value);
      setQty(qty ? qty.value : 1);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initMukPdpV3(document); });
  } else {
    initMukPdpV3(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initMukPdpV3(event.target); });
})();

/* ============================================================
   MUK PLP V3 — filters, sort, variants and AJAX cart drawer
   ============================================================ */
(function () {
  'use strict';

  function openMiniCart(response) {
    try {
      if (response.sections && window.Alpine && Alpine.store('xCartHelper')) {
        Alpine.store('xCartHelper').getSectionsToRender().forEach(function (section) {
          var element = document.querySelector(section.selector);
          if (!element || !response.sections[section.id]) return;
          if (typeof window.getSectionInnerHTML === 'function') {
            element.innerHTML = window.getSectionInnerHTML(response.sections[section.id], section.selector);
          } else {
            var parsed = new DOMParser().parseFromString(response.sections[section.id], 'text/html');
            var replacement = parsed.querySelector(section.selector);
            element.innerHTML = replacement ? replacement.innerHTML : response.sections[section.id];
          }
        });
      }

      if (window.Alpine && Alpine.store('xMiniCart')) {
        if (!response.sections && Alpine.store('xMiniCart').reLoad) Alpine.store('xMiniCart').reLoad();
        Alpine.store('xMiniCart').openCart();
      } else {
        window.location.href = '/cart';
      }
      document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
    } catch (error) {
      window.location.href = '/cart';
    }
  }

  function ajaxAdd(form) {
    var button = form.querySelector('[data-muk-card-add]');
    var select = form.querySelector('[data-muk-card-variant]');
    if (select && !select.value) return;
    if (!button || button.disabled) return;

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    var originalText = button.textContent;
    button.textContent = 'Adding…';

    var data = new FormData(form);
    try {
      if (window.Alpine && Alpine.store('xCartHelper')) {
        data.append('sections', Alpine.store('xCartHelper').getSectionsToRender().map(function (section) { return section.id; }));
        data.append('sections_url', window.location.pathname);
      }
    } catch (e) {}

    fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: data
    })
      .then(function (response) { return response.json(); })
      .then(function (response) {
        if (response.status === 422) throw new Error(response.description || 'Unable to add item to cart');
        openMiniCart(response);
      })
      .catch(function (error) {
        console.error(error);
        window.location.href = '/cart';
      })
      .finally(function () {
        button.removeAttribute('aria-busy');
        button.textContent = originalText;
        if (!select || select.value) button.disabled = false;
      });
  }

  function bindPlpCardForms(root) {
    if (!root) return;
    root.querySelectorAll('[data-muk-plp-cart-form]').forEach(function (form) {
      if (form.__mukPlpCartBound) return;
      form.__mukPlpCartBound = true;
      var select = form.querySelector('[data-muk-card-variant]');
      var button = form.querySelector('[data-muk-card-add]');
      if (select && button) {
        var card = form.closest('[data-muk-plp-card]');
        var cardImage = card && (card.querySelector('.muk-plp-card__image--primary') || card.querySelector('.muk-plp-card__image'));
        button.disabled = !select.value;
        select.addEventListener('change', function () {
          button.disabled = !select.value;
          var selectedOption = select.options[select.selectedIndex];
          var variantImage = selectedOption && selectedOption.getAttribute('data-variant-image');
          if (variantImage && cardImage) {
            cardImage.src = variantImage;
            cardImage.removeAttribute('srcset');
            cardImage.removeAttribute('sizes');
          }
        });
      }
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        ajaxAdd(form);
      });
    });
  }

  function initPlp(scope) {
    (scope || document).querySelectorAll('[data-muk-plp]').forEach(function (root) {
      if (root.__mukPlpBound) return;
      root.__mukPlpBound = true;

      var catalog = root.querySelector('[data-muk-catalog]');
      var toggle = root.querySelector('[data-muk-filter-toggle]');
      var close = root.querySelector('[data-muk-filter-close]');
      var backdrop = root.querySelector('[data-muk-filter-backdrop]');
      var mobileQuery = window.matchMedia('(max-width: 990px)');

      var sortDetails = root.querySelector('[data-muk-sort]');
      var filtersPanel = root.querySelector('[data-muk-filters]');

      function positionFloatingFilters() {
        if (!mobileQuery.matches || !toggle || !filtersPanel) return;
        var rect = toggle.getBoundingClientRect();
        var left = Math.max(12, Math.min(rect.left, window.innerWidth - Math.min(360, window.innerWidth - 24) - 12));
        root.style.setProperty('--muk-filter-left', Math.round(left) + 'px');
        root.style.setProperty('--muk-filter-top', Math.round(rect.bottom + 8) + 'px');
      }

      function closeFilters() {
        root.classList.remove('is-mobile-filter-open');
        root.classList.remove('is-filter-overlay-open');
        if (catalog) catalog.classList.remove('is-filter-open');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
        document.documentElement.style.overflow = '';
    document.body.classList.remove('muk-pdp-video-modal-open');
      }

      function toggleFilters() {
        if (!catalog) return;
        var opening = !catalog.classList.contains('is-filter-open');
        if (opening && sortDetails) sortDetails.open = false;
        catalog.classList.toggle('is-filter-open', opening);
        root.classList.toggle('is-filter-overlay-open', opening);
        root.classList.toggle('is-mobile-filter-open', opening && mobileQuery.matches);
        if (toggle) toggle.setAttribute('aria-expanded', String(opening));
        if (opening) {
          positionFloatingFilters();
          var groups = Array.prototype.slice.call(root.querySelectorAll('.muk-plp__filter-group'));
          var availability = groups.find(function (group) {
            var label = group.querySelector('summary span');
            return label && label.textContent.trim().toLowerCase() === 'availability';
          });
          if (availability) {
            groups.forEach(function (group) { if (group !== availability) group.open = false; });
            availability.open = true;
          }
        }
        document.documentElement.style.overflow = '';
      }

      if (toggle) toggle.addEventListener('click', toggleFilters);
      function syncFloatingFiltersPosition() {
        if (!root.classList.contains('is-mobile-filter-open')) return;
        positionFloatingFilters();
      }
      window.addEventListener('scroll', syncFloatingFiltersPosition, { passive: true });
      window.addEventListener('resize', syncFloatingFiltersPosition);
      if (sortDetails) {
        var sortSummary = sortDetails.querySelector('summary');
        if (sortSummary) sortSummary.addEventListener('click', function(){ closeFilters(); }, true);
      }
      if (close) close.addEventListener('click', closeFilters);
      if (backdrop) backdrop.addEventListener('click', closeFilters);
      root.addEventListener('click', function (event) {
        if (root.classList.contains('is-mobile-filter-open') && event.target === root) closeFilters();
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') closeFilters();
      });
      mobileQuery.addEventListener && mobileQuery.addEventListener('change', closeFilters);
      /* Merchandising tile order and sizing are CSS/Liquid driven; no post-load DOM movement. */
      var relatedPills = root.querySelector('[data-muk-related-pills]');
      if (relatedPills) {
        var relatedLinks = Array.prototype.slice.call(relatedPills.querySelectorAll('a'));
        var relatedToggle = relatedPills.querySelector('[data-muk-related-toggle]');
        var relatedToggleLabel = relatedPills.querySelector('[data-muk-related-toggle-label]');

        if (relatedToggle && relatedLinks.length > 5) {
          relatedPills.classList.add('is-collapsed');
          relatedToggle.hidden = false;
          relatedToggle.addEventListener('click', function () {
            var expanding = relatedPills.classList.contains('is-collapsed');
            relatedPills.classList.toggle('is-collapsed', !expanding);
            relatedToggle.setAttribute('aria-expanded', String(expanding));
            if (relatedToggleLabel) relatedToggleLabel.textContent = expanding ? 'View less' : 'View more';
          });
        }
      }

      bindPlpCardForms(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initPlp(document); });
  } else {
    initPlp(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initPlp(event.target); });
  document.addEventListener('muk:plp:balanced', function (event) {
    var root = event.detail && event.detail.root ? event.detail.root : document.querySelector('[data-muk-plp]');
    bindPlpCardForms(root);
  });
})();


/* MUK R35 — product cards outside PLP/PDP (homepage tabs, routine feeds, etc.). */
(function () {
  function openCartAfterAdd() {
    try {
      if (window.Alpine && Alpine.store('xMiniCart')) {
        if (Alpine.store('xMiniCart').reLoad) Alpine.store('xMiniCart').reLoad();
        Alpine.store('xMiniCart').openCart();
      }
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
  }

  function bindCards(scope) {
    (scope || document).querySelectorAll('[data-muk-plp-cart-form]').forEach(function (form) {
      if (form.__mukPlpCartBound || form.__mukPdpCardBound || form.__mukGlobalCardBound) return;
      form.__mukGlobalCardBound = true;

      var select = form.querySelector('[data-muk-card-variant]');
      var button = form.querySelector('[data-muk-card-add]') || form.querySelector('[type="submit"]');
      var card = form.closest('[data-muk-plp-card]');
      var image = card && card.querySelector('.muk-plp-card__image--primary');

      function sync() {
        if (!select || !button) return;
        var option = select.options[select.selectedIndex];
        button.disabled = !select.value || !!(option && option.disabled);
        var imageSrc = option && option.getAttribute('data-variant-image');
        if (imageSrc && image) {
          image.src = imageSrc;
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
        }
        var control = select.closest('[data-muk-card-variant-control]');
        var priceNode = control && control.querySelector('[data-muk-card-variant-price]');
        if (priceNode && option) {
          var priceText = option.getAttribute('data-variant-price') || '';
          var unitText = option.getAttribute('data-variant-unit-price') || '';
          if (!unitText) {
            var labelText = option.getAttribute('data-variant-label') || option.textContent || '';
            var mlMatch = labelText.match(/(\d+(?:\.\d+)?)\s*m[lL]\b/);
            var priceCents = parseInt(option.getAttribute('data-variant-price-cents') || '', 10);
            if (mlMatch && priceCents > 0) {
              var ml = parseFloat(mlMatch[1]);
              if (ml > 0) unitText = '$' + ((priceCents / 100) / ml).toFixed(2) + '/mL';
            }
          }
          priceNode.textContent = priceText + (unitText ? ' (' + unitText + ')' : '');
        }
      }

      if (select) {
        sync();
        select.addEventListener('change', sync);
      }

      form.addEventListener('submit', function (event) {
        if (select && !select.value) { event.preventDefault(); return; }
        if (!button || button.disabled) { event.preventDefault(); return; }

        event.preventDefault();
        var original = button.textContent;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.textContent = 'Adding…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form)
        })
          .then(function (response) {
            if (!response.ok) return response.json().then(function (data) { throw new Error(data.description || 'Unable to add item'); });
            return response.json();
          })
          .then(openCartAfterAdd)
          .catch(function (error) { console.error(error); })
          .finally(function () {
            button.removeAttribute('aria-busy');
            button.textContent = original;
            if (!select || select.value) button.disabled = false;
          });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bindCards(document); });
  } else {
    bindCards(document);
  }
  document.addEventListener('shopify:section:load', function (event) { bindCards(event.target); });
})();


/* MUK R50 — routine bundle add-to-cart reliability. */
(function () {
  function bindRoutineForms(scope) {
    (scope || document).querySelectorAll('.routine-add-form').forEach(function (form) {
      if (form.__mukRoutineBound) return;
      form.__mukRoutineBound = true;

      form.addEventListener('submit', function (event) {
        var button = form.querySelector('[type="submit"]');
        if (!button || button.disabled) {
          event.preventDefault();
          return;
        }

        event.preventDefault();
        var originalLabel = button.textContent;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.textContent = 'Adding…';

        var formData = new FormData(form);
        var cartHelper = null;
        try {
          if (window.Alpine && Alpine.store('xCartHelper')) {
            cartHelper = Alpine.store('xCartHelper');
            var sections = cartHelper.getSectionsToRender && cartHelper.getSectionsToRender();
            if (sections && sections.length) {
              formData.append('sections', sections.map(function (section) { return section.id; }).join(','));
              formData.append('sections_url', window.location.pathname);
            }
          }
        } catch (error) {}

        var shopRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
        fetch(shopRoot + 'cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        })
          .then(function (response) {
            return response.json().then(function (data) {
              if (!response.ok || data.status === 422) {
                throw new Error(data.description || 'Unable to add routine to cart');
              }
              return data;
            });
          })
          .then(function (response) {
            try {
              if (response.sections && cartHelper && cartHelper.getSectionsToRender) {
                cartHelper.getSectionsToRender().forEach(function (section) {
                  var element = document.querySelector(section.selector);
                  if (!element || !response.sections[section.id]) return;
                  var parsed = new DOMParser().parseFromString(response.sections[section.id], 'text/html');
                  var replacement = parsed.querySelector(section.selector);
                  element.innerHTML = replacement ? replacement.innerHTML : response.sections[section.id];
                });
              }

              if (window.Alpine && Alpine.store('xMiniCart')) {
                var miniCart = Alpine.store('xMiniCart');
                if (!response.sections && miniCart.reLoad) miniCart.reLoad();
                miniCart.openCart();
              }
            } catch (error) {
              console.warn('MUK routine cart drawer refresh failed:', error);
            }

            document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
            if (typeof window.mukRefreshCartCount === 'function') window.mukRefreshCartCount();
          })
          .catch(function (error) {
            console.error('MUK routine add failed:', error);
            // Native cart is the safest fallback if a third-party cart integration rejects AJAX.
            form.submit();
          })
          .finally(function () {
            button.removeAttribute('aria-busy');
            button.textContent = originalLabel;
            button.disabled = false;
          });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bindRoutineForms(document); });
  } else {
    bindRoutineForms(document);
  }
  document.addEventListener('shopify:section:load', function (event) { bindRoutineForms(event.target); });
})();


(function () {
  function mukSyncVariantSummary(select) {
    if (!select) return;
    var control = select.closest('[data-muk-card-variant-control]');
    if (!control) return;
    var option = select.options[select.selectedIndex];
    if (!option) return;
    var label = control.querySelector('[data-muk-card-variant-label]');
    var price = control.querySelector('[data-muk-card-variant-price]');
    var variantLabel = option.getAttribute('data-variant-label') || option.textContent || '';
    var variantPrice = option.getAttribute('data-variant-price') || '';
    var unitPrice = option.getAttribute('data-variant-unit-price') || '';
    if (label) label.textContent = variantLabel.replace(/\s+—\s+Sold out$/, '');
    if (price) price.textContent = variantPrice + (unitPrice ? ' (' + unitPrice + ')' : '');
  }
  function init(scope) {
    (scope || document).querySelectorAll('[data-muk-card-variant-control] [data-muk-card-variant]').forEach(function (select) {
      mukSyncVariantSummary(select);
      if (select.__mukSummaryBound) return;
      select.__mukSummaryBound = true;
      select.addEventListener('change', function () { mukSyncVariantSummary(select); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();

/* MUK B2C: the After muk menu item is a single-product destination, not a collection. */
(function () {
  function updateAfterMukMenuLinks(root) {
    (root || document).querySelectorAll('header a, nav a, [role="navigation"] a').forEach(function (a) {
      var label = (a.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (label === 'after muk' || label === 'after make') {
        a.setAttribute('href', '/products/after-muk-texture-spray');
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ updateAfterMukMenuLinks(document); });
  else updateAfterMukMenuLinks(document);
  document.addEventListener('shopify:section:load', function(e){ updateAfterMukMenuLinks(e.target); });
})();


/* Smooth FAQ accordion open / close animation. */
(() => {
  const selector = '.muk-faq-page__item, .muk-pdp-v3__faq-item, .muk-plp__faq-item';
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initFaqAccordion(details) {
    if (!details || details.dataset.mukAccordionReady === 'true') return;
    const summary = details.querySelector(':scope > summary');
    if (!summary) return;
    details.dataset.mukAccordionReady = 'true';
    details.style.overflow = 'hidden';

    let animation = null;
    let closing = false;
    let expanding = false;

    const finish = (open) => {
      if (animation) animation.cancel();
      animation = null;
      closing = false;
      expanding = false;
      details.open = open;
      details.style.height = '';
      const answer = details.querySelector(':scope > div');
      if (answer) answer.style.opacity = '';
    };

    const animateTo = (startHeight, endHeight, opening) => {
      if (prefersReduced.matches) {
        finish(opening);
        return;
      }
      const answer = details.querySelector(':scope > div');
      animation = details.animate(
        { height: [`${startHeight}px`, `${endHeight}px`] },
        { duration: 280, easing: 'cubic-bezier(.22,.61,.36,1)' }
      );
      if (answer) {
        answer.animate(
          { opacity: opening ? [0, 1] : [1, 0] },
          { duration: opening ? 220 : 160, easing: 'ease-out', fill: 'forwards' }
        );
      }
      animation.onfinish = () => finish(opening);
      animation.oncancel = () => {};
    };

    summary.addEventListener('click', (event) => {
      event.preventDefault();
      if (animation) animation.cancel();

      const startHeight = details.getBoundingClientRect().height;
      const summaryHeight = summary.getBoundingClientRect().height;

      if (!details.open || closing) {
        document.querySelectorAll(selector).forEach((other) => {
          if (other === details || !other.open) return;
          const otherSummary = other.querySelector(':scope > summary');
          if (otherSummary) otherSummary.click();
          else other.open = false;
        });
        details.open = true;
        closing = false;
        expanding = true;
        details.style.height = `${startHeight}px`;
        requestAnimationFrame(() => {
          const endHeight = details.scrollHeight;
          animateTo(startHeight || summaryHeight, endHeight, true);
        });
      } else if (details.open || expanding) {
        closing = true;
        expanding = false;
        animateTo(startHeight, summaryHeight, false);
      }
    });
  }

  const initAll = (scope = document) => scope.querySelectorAll(selector).forEach(initFaqAccordion);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
      if (!(node instanceof Element)) return;
      if (node.matches(selector)) initFaqAccordion(node);
      initAll(node);
    }));
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* MUK PDP Tips video modal – scoped to product pages. */
(function () {
  if (window.__mukPdpTipsModalBound) return;
  window.__mukPdpTipsModalBound = true;

  function closeModal(modal) {
    if (!modal) return;
    var video = modal.querySelector('video');
    if (video) video.pause();
    var frame = modal.querySelector('iframe');
    if (frame && frame.contentWindow) {
      try {
        frame.contentWindow.postMessage(JSON.stringify({method:'pause'}), '*');
        frame.contentWindow.postMessage(JSON.stringify({event:'command',func:'pauseVideo',args:[]}), '*');
      } catch(e) {}
    }
    modal.remove();
    document.documentElement.style.overflow = '';
    document.body.classList.remove('muk-pdp-video-modal-open');
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest && event.target.closest('[data-muk-tip-video-open]');
    if (opener) {
      event.preventDefault();
      var src = opener.getAttribute('data-video-src');
      if (!src) return;
      var direct = opener.getAttribute('data-video-direct') === 'true';
      var sourceMedia = opener.closest('.muk-pdp-v3__tips-media');
      var sourceVideo = sourceMedia && sourceMedia.querySelector('video');
      var sourceFrame = sourceMedia && sourceMedia.querySelector('iframe');
      if (sourceVideo) { sourceVideo.pause(); sourceVideo.muted = true; }
      if (sourceMedia) {
        var sourceSoundButton = sourceMedia.querySelector('[data-muk-video-sound]');
        var sourceSoundLabel = sourceMedia.querySelector('[data-muk-video-sound-label]');
        if (sourceSoundButton) sourceSoundButton.setAttribute('aria-pressed', 'false');
        if (sourceSoundLabel) sourceSoundLabel.textContent = 'Unmute';
      }
      if (sourceFrame && sourceFrame.contentWindow) {
        try {
          sourceFrame.contentWindow.postMessage(JSON.stringify({method:'pause'}), '*');
          sourceFrame.contentWindow.postMessage(JSON.stringify({method:'setVolume', value:0}), '*');
          sourceFrame.contentWindow.postMessage(JSON.stringify({event:'command',func:'pauseVideo',args:[]}), '*');
          sourceFrame.contentWindow.postMessage(JSON.stringify({event:'command',func:'mute',args:[]}), '*');
        } catch(e) {}
      }
      var existingModal = document.querySelector('.muk-pdp-video-modal');
      if (existingModal) closeModal(existingModal);
      var modal = document.createElement('div');
      modal.className = 'muk-pdp-video-modal';
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.innerHTML = '<div class="muk-pdp-video-modal__inner"><button type="button" class="muk-pdp-video-modal__close" aria-label="Close video">×</button><div class="muk-pdp-video-modal__controls" aria-label="Video controls"><button type="button" data-muk-modal-play aria-pressed="true">Pause</button><button type="button" data-muk-modal-mute aria-pressed="false">Mute</button></div></div>';
      var inner = modal.querySelector('.muk-pdp-video-modal__inner');
      var modalMedia = null;
      if (direct) {
        var video = document.createElement('video');
        video.src = src;
        video.controls = false;
        video.autoplay = true;
        video.muted = false;
        video.playsInline = true;
        inner.appendChild(video);
        modalMedia = video;
      } else {
        var iframe = document.createElement('iframe');
        try { var modalUrl = new URL(src, window.location.href); modalUrl.searchParams.set('autoplay','1'); modalUrl.searchParams.set('muted','0'); modalUrl.searchParams.set('controls','1'); modalUrl.searchParams.set('background','0'); src = modalUrl.toString(); } catch(e) {}
        iframe.src = src;
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        iframe.allowFullscreen = true;
        iframe.title = 'muk product video';
        inner.appendChild(iframe);
        modalMedia = iframe;
      }
      var playButton = inner.querySelector('[data-muk-modal-play]');
      var muteButton = inner.querySelector('[data-muk-modal-mute]');
      var playing = true;
      var muted = false;
      function sendFrameCommand(frame, play, mute) {
        if (!frame || !frame.contentWindow) return;
        try {
          if (play !== null) {
            frame.contentWindow.postMessage(JSON.stringify({method: play ? 'play' : 'pause'}), '*');
            frame.contentWindow.postMessage(JSON.stringify({event:'command',func: play ? 'playVideo' : 'pauseVideo',args:[]}), '*');
          }
          if (mute !== null) {
            frame.contentWindow.postMessage(JSON.stringify({method:'setVolume', value: mute ? 0 : 1}), '*');
            frame.contentWindow.postMessage(JSON.stringify({event:'command',func: mute ? 'mute' : 'unMute',args:[]}), '*');
          }
        } catch(e) {}
      }
      playButton?.addEventListener('click', function(){
        playing = !playing;
        playButton.setAttribute('aria-pressed', playing ? 'true' : 'false');
        playButton.textContent = playing ? 'Pause' : 'Play';
        if (modalMedia && modalMedia.tagName === 'VIDEO') { if (playing) modalMedia.play().catch(function(){}); else modalMedia.pause(); }
        else sendFrameCommand(modalMedia, playing, null);
      });
      muteButton?.addEventListener('click', function(){
        muted = !muted;
        muteButton.setAttribute('aria-pressed', muted ? 'true' : 'false');
        muteButton.textContent = muted ? 'Unmute' : 'Mute';
        if (modalMedia && modalMedia.tagName === 'VIDEO') modalMedia.muted = muted;
        else sendFrameCommand(modalMedia, null, muted);
      });
      document.body.appendChild(modal);
      document.documentElement.style.overflow = 'hidden';
      document.body.classList.add('muk-pdp-video-modal-open');
      modal.querySelector('.muk-pdp-video-modal__close').focus();
      return;
    }

    var modal = event.target.closest && event.target.closest('.muk-pdp-video-modal');
    if (modal && (event.target === modal || event.target.closest('.muk-pdp-video-modal__close'))) {
      closeModal(modal);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    closeModal(document.querySelector('.muk-pdp-video-modal'));
  });
})();


/* R65 BugHerd UAT pass — card variant labels/prices and resilient image switching. */
(function(){
  function syncCard(select){
    if(!select) return;
    var option=select.options[select.selectedIndex];
    var card=select.closest('[data-muk-plp-card]');
    if(!option||!card) return;
    var image=card.querySelector('.muk-plp-card__image--primary');
    var imageSrc=option.getAttribute('data-variant-image');
    if(image&&imageSrc){ image.src=imageSrc; image.removeAttribute('srcset'); image.removeAttribute('sizes'); }
    var control=select.closest('[data-muk-card-variant-control]');
    if(!control) return;
    var label=control.querySelector('[data-muk-card-variant-label]');
    var price=control.querySelector('[data-muk-card-variant-price]');
    if(label) label.textContent=option.getAttribute('data-variant-label')||option.textContent||'';
    if(price){
      var p=option.getAttribute('data-variant-price')||'';
      var unit=option.getAttribute('data-variant-unit-price')||'';
      if(!unit){
        var m=(option.getAttribute('data-variant-label')||option.textContent||'').match(/(\d+(?:\.\d+)?)\s*m[lL]\b/);
        var cents=parseInt(option.getAttribute('data-variant-price-cents')||'',10);
        if(m&&cents>0){ var ml=parseFloat(m[1]); if(ml>0) unit='$'+((cents/100)/ml).toFixed(2)+'/mL'; }
      }
      price.textContent=p+(unit?' ('+unit+')':'');
    }
  }
  function init(scope){
    (scope||document).querySelectorAll('[data-muk-card-variant]').forEach(function(select){
      if(select.__mukR65Bound) return;
      select.__mukR65Bound=true;
      syncCard(select);
      select.addEventListener('change',function(){syncCard(select);});
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){init(document);}); else init(document);
  document.addEventListener('shopify:section:load',function(e){init(e.target);});
})();
